module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/incense@2x_2e7cc2.jpg";